import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { cn } from "@/shared/lib/utils";
import type { ReactNode } from "react";

const sizeClass = {
  sm: "sm:max-w-md",
  md: "sm:max-w-lg",
  lg: "sm:max-w-2xl",
} as const;

export type ModalProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  className?: string;
  size?: keyof typeof sizeClass;
  footer?: ReactNode;
  showCloseButton?: boolean;
  /** จำกัดความสูง + scroll เนื้อหา — ใช้กับฟอร์มยาว */
  scrollable?: boolean;
};

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  className,
  size = "md",
  footer,
  showCloseButton = true,
  scrollable = false,
}: ModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn(
          sizeClass[size],
          scrollable &&
            "flex max-h-[min(90vh,40rem)] max-w-[min(100vw-2rem,32rem)] flex-col gap-0 overflow-hidden p-0 sm:max-w-lg",
          className,
        )}
        showCloseButton={showCloseButton}
      >
        {title || description ? (
          <DialogHeader
            className={cn(
              scrollable && "shrink-0 space-y-1 border-b px-4 pt-4 pr-12 pb-3",
            )}
          >
            {title ? <DialogTitle>{title}</DialogTitle> : null}
            {description ? (
              <DialogDescription>{description}</DialogDescription>
            ) : null}
          </DialogHeader>
        ) : null}
        {scrollable ? (
          <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-4 py-4">
            {children}
          </div>
        ) : (
          children
        )}
        {footer ? (
          <DialogFooter
            className={cn(scrollable && "shrink-0 border-t px-4 py-3")}
          >
            {footer}
          </DialogFooter>
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
